module.exports = __webpack_public_path__ + "static/media/footer_desktop@2x.174ae1b9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/planning/footer_desktop@2x.jpg
 ** module id = 2362
 ** module chunks = 44
 **/